import React from 'react';

interface Props {
  mainContainerClassName?: string;
  title?: string;
  progressBarContainerClass?: string;
  progressContainerStyle?: React.CSSProperties;
  currentProgress: number;
  minimumProgress?: number;
  maximumProgress?: number;
  progressWidth: number;
  titleClassName?: string;
  backgroundColor?: string;
  showProgressDigits?: boolean;
  showTitle?: boolean;
}

const NewProgressBar = (props: Props) => {
  const {
    mainContainerClassName,
    title,
    progressBarContainerClass,
    progressContainerStyle,
    currentProgress,
    minimumProgress,
    maximumProgress,
    progressWidth,
    backgroundColor,
    showProgressDigits = true,
    showTitle = true,
  } = props;
  return (
    <div id="new-progress-bar-main-container" className={mainContainerClassName}>
      {showTitle && (
        <div id="new-progress-bar-title" className={props.titleClassName + ' taskTitle'}>
          {' '}
          {title}{' '}
        </div>
      )}
      <div
        id="new-progress-bar-progress-bar-container"
        className={progressBarContainerClass}
      >
        <div
          id="new-progress-bar-progress-bar-style"
          role="progressbar"
          aria-valuenow={currentProgress}
          aria-valuemin={minimumProgress || 0}
          aria-valuemax={maximumProgress || 100}
          style={{
            ...progressContainerStyle,
            width: `${progressWidth}%`,
            backgroundColor: backgroundColor ?? '#4CAF50',
          }}
        ></div>
      </div>
      {`${showProgressDigits === true ? currentProgress + '%' : ''}`}
    </div>
  );
};

export default NewProgressBar;
